import { Resolution } from 'src/domains/calculators/utilities/types';

export function getSimplifiedAspectRatio(
  roundedDesqueezedAspectRatioResolution: Resolution
): Resolution {
  const { width, height } = roundedDesqueezedAspectRatioResolution;

  // Divide both numbers by their greatest common divisor
  const gcd = (a: number, b: number): number => {
    if (b === 0) return a;
    return gcd(b, a % b);
  };

  const divisor = gcd(width, height);

  return {
    width: width / divisor,
    height: height / divisor,
  };
}
